import { CardOnFileFormJustifiProps } from '../../../components/card-on-file/form/form-justifi';
import { CardOnFileFormStripeProps } from '../../../components/card-on-file/form/form-stripe';
import { GatewaySwitch } from '../../../components/switches/gateway-switch';
import { useCardOnFileJustifiContext } from '../context/card-on-file-justifi.context';
import { useCardOnFileStripeContext } from '../context/card-on-file-stripe.context';

export type CardOnFileContextToFormProps = {
  stripeComponent: React.FC<CardOnFileFormStripeProps>;
  justifiComponent: React.FC<CardOnFileFormJustifiProps>;
};
export const CardOnFileContextToForm = ({
  stripeComponent: StripeComponent,
  justifiComponent: JustifiComponent,
}: CardOnFileContextToFormProps) => {
  return (
    <GatewaySwitch
      stripeContent={StripeFormWithContext}
      stripeProps={{ render: StripeComponent }}
      justifiContent={JustifiFormWithContext}
      justifiProps={{ render: JustifiComponent }}
    />
  );
};

const StripeFormWithContext = ({ render: RenderStripeComponent }: { render: React.FC<CardOnFileFormStripeProps> }) => {
  const { setCardReadyToSubmit, nameFieldProps, shouldShowLoading } = useCardOnFileStripeContext();

  return (
    <RenderStripeComponent
      setCardReadyToSubmit={setCardReadyToSubmit}
      nameFieldProps={nameFieldProps}
      shouldShowLoading={shouldShowLoading}
    />
  );
};

const JustifiFormWithContext = ({
  render: RenderJustifiComponent,
}: {
  render: React.FC<CardOnFileFormJustifiProps>;
}) => {
  const { shouldShowLoading, nameFieldProps, justifiProps, elementRef } = useCardOnFileJustifiContext();

  return (
    <RenderJustifiComponent
      shouldShowLoading={shouldShowLoading}
      nameFieldProps={nameFieldProps}
      justifiProps={justifiProps}
      elementRef={elementRef}
    />
  );
};
